import RootCacheMixin from 'GroomyRoot/mixins/Cache.js'

export default {
    mixins: [RootCacheMixin]
}